import { PublicClientApplication } from '@azure/msal-browser'
import { InteractionRequiredAuthError } from '@azure/msal-browser'
import { msalConfig, loginRequest } from '../constants/auth/authConfig'


export const getToken = async () => {

  const pca = new PublicClientApplication(msalConfig);
  await pca.initialize();

  const accounts = pca.getAllAccounts();
  if (accounts.length === 0) {
    // If no accounts are found, initiate interactive login
    const loginResponse = await pca.loginPopup({
      scopes: loginRequest.scopes,
    });
    return loginResponse.accessToken;
  }

  const account = accounts[0];
  try {
    const resp = await pca.acquireTokenSilent({
      scopes: loginRequest.scopes,
      account,
    });
    return resp.accessToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      // If an interactive request is required, use a popup login
      const resp = await pca.acquireTokenPopup({
        scopes: loginRequest.scopes,
        account,
      });
      return resp.accessToken;
    } else {
      throw error;
    }
  }
};